import React, { useEffect, useState, useCallback } from "react";
import HomeNew from "./homeNew.view";
import * as SessionService from "../../../services/SessionService";
import * as CourseService from "../../../services/CourseService";
import moment from "moment-timezone";

const HomeNewContainer = () => {
  const [requestData, setRequestData] = useState([]);
  const [stats, setStats] = useState({
    totalSessions: 0,
    upcomingSessions: 0,
    courseCategories: 0,
  });

  const loadData = useCallback(async () => {
    // Cargar sesiones
    const result = await SessionService.listFilter({
      completed: false,
      sort: "date",
    });

    if (result) {
      setRequestData(result.docs);

      // Calcular estadísticas
      const currentMonth = moment().format("YYYY-MM");
      const now = moment();

      // Total de sesiones este mes
      const totalSessionsThisMonth = result.docs.filter((session) => {
        return moment(session.date).format("YYYY-MM") === currentMonth;
      }).length;

      // Sesiones próximas (futuras)
      const upcomingSessions = result.docs.filter((session) => {
        return moment(session.date).isAfter(now);
      }).length;

      setStats((prev) => ({
        ...prev,
        totalSessions: totalSessionsThisMonth,
        upcomingSessions: upcomingSessions,
      }));
    }

    // Cargar categorías de cursos
    try {
      const courses = await CourseService.listCourse({});
      if (courses) {
        // Contar categorías únicas (si tienen categorías) o simplemente contar cursos
        const uniqueCategories = new Set(
          courses.map((course) => course.category || course.uuid)
        );
        setStats((prev) => ({
          ...prev,
          courseCategories: uniqueCategories.size,
        }));
      }
    } catch (error) {
      console.error("Error loading course categories:", error);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return <HomeNew requestData={requestData} stats={stats} />;
};

HomeNewContainer.propTypes = {};

export default HomeNewContainer;
